module.exports = __webpack_public_path__ + "static/media/FD_Logo.e76eb2ad.png";